import { render, staticRenderFns } from "./Geometry.vue?vue&type=template&id=001d7a04&scoped=true"
import script from "./Geometry.vue?vue&type=script&lang=ts"
export * from "./Geometry.vue?vue&type=script&lang=ts"
import style0 from "./Geometry.vue?vue&type=style&index=0&id=001d7a04&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001d7a04",
  null
  
)

export default component.exports